/**
 * Configuration centralisée de l'application
 * Pour éviter les divergences de noms et URLs (principe DRY)
 */

// Récupérer la sitekey depuis l'env ou utiliser la valeur par défaut
// Note: import.meta.env est fourni par Vite
const getHCaptchaSiteKey = (): string => {
  try {
    // @ts-ignore - Vite injecte import.meta.env à la compilation
    return import.meta.env?.VITE_PUBLIC_HCAPTCHA_SITEKEY || '3a6cde46-0374-4ce4-bfa4-b32e99bcead6';
  } catch {
    return '3a6cde46-0374-4ce4-bfa4-b32e99bcead6';
  }
};

export const APP_CONFIG = {
  // hCaptcha
  captcha: {
    siteKey: getHCaptchaSiteKey(),
  },
  
  // Validation email institutionnel
  validEmailDomains: ['@etu.hesge.ch'],
  
  // Nom de l'application
  name: 'Tutormatch - HEG-Genève',
  shortName: 'Tutormatch',
  tagline: 'Plateforme de tutorat entre étudiant-es de la HEG-Genève',
  
  // URLs
  url: 'https://www.tutormatch-heg-ge.ch',
  supportEmail: 'support@tutormatch-heg-ge.ch',
  
  // Partenaires
  partners: {
    aeheg: {
      name: 'AEHEG',
      fullName: 'Association des Étudiant-es HEG',
      url: 'https://aeheg.com',
    },
    heg: {
      name: 'HEG-Genève',
      fullName: 'Haute école de gestion de Genève',
      url: 'https://www.hesge.ch/heg',
    },
    hesso: {
      name: 'HES-SO Genève',
      fullName: 'Haute École Spécialisée de Suisse occidentale',
      url: 'https://www.hesge.ch',
    },
  },
  
  // Réseaux sociaux / Meta
  social: {
    description: 'Trouve un-e tuteur-trice HEG-Genève en 60 secondes. Plateforme officielle de tutorat entre étudiant-es de la Haute école de gestion de Genève.',
    keywords: 'tutorat, HEG, Genève, étudiant, tuteur, aide aux devoirs, cours particuliers',
  },
} as const;

// Export du nom pour usage rapide
export const APP_NAME = APP_CONFIG.name;

